import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "../App.css";

// Import images
import BCALogo from "../img/footer/Bcawidgets.png";
import BBBLogo from "../img/footer/BBB-logo.png";
import Top50 from "../img/footer/Top 50 logo-01.svg";

export default function DisclaimerAndBadges() {
  const getSunWestSuccessYears = () => {
    // Sun West founded in 08/12/1980 in PST
    const foundedDate = new Date("1980-08-12T00:00:00-07:00"); // PST offset is -07:00
    const todayDate = new Date();

    // Adjust todayDate to PST timezone
    const todayPST = new Date(
      todayDate.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );

    const yearDiff = todayPST.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday =
      todayPST.getMonth() < foundedDate.getMonth() ||
      (todayPST.getMonth() === foundedDate.getMonth() &&
        todayPST.getDate() < foundedDate.getDate());

    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
  };
  return (
    <>
      <Container className="DisclaimerSection">
        <Row className="pt-4 pb-5 d-flex justify-content-center text-center">
          <Col
            xs={12}
            md={3}
            lg={3}
            className="logo-column-1 d-flex flex-column justify-content-between mb-3 text-center"
            style={{ paddingTop: "20px" }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.bbb.org/us/ca/buena-park/profile/mortgage-banker/sun-west-mortgage-company-inc-1126-172020499"
              className="mb-2"
            >
              <Image
                src={BBBLogo}
                className="md-small-image"
                alt="BBB accredited business"
                style={{ height: "68px" }}
              />
            </a>
            <div style={{ paddingTop: "0px" }}>
              <a
                href="https://www.checkbca.org/report/sun-west-mortgage-company-inc-59000209"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={BCALogo}
                  alt="Bca logo"
                  style={{ width: "170px" }}
                  className="md-small-image"
                />
              </a>
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            lg={2}
            className="mb-2"
            style={{ paddingTop: "20px" }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://sunwestmortgage.com/"
              className="mb-3"
            >
              <Image
                src={Top50}
                alt="Mortgage Executive Top 50 logo"
                title="Mortgage Executive Top 50"
                style={{ height: "200px" }}
              />
            </a>
          </Col>
          <Col xs={12} md={2} lg={2} style={{ paddingTop: "20px" }}>
            <Image
              src={process.env.REACT_APP_CDN_LINK + "swmc-images/Years-Of-Trust_Blue.webp"}
              alt={`Sun West ${getSunWestSuccessYears()} years logo`}
              title={`Sun West ${getSunWestSuccessYears()} years logo`}
              className="mb-3"
              style={{ height: "200px" }}
            />
          </Col>
        </Row>
      </Container>

      <Container className="taca_specific_footer mb-4">
        <Row className="justify-content-center">
          <Col md={11}>
            <span className="taca_specific_footer_span">
              Our products and services have no affiliation with or endorsement
              from any government agency or body. :- This disclaimer is generic
              in nature so we can keep this disclaimer as well.
              <br />
              Sun West Mortgage Company, Inc. is acting as the Lender and offers
              financing to qualified borrowers. Kickin' Cancer Foundation - a
              third party organization is not affiliated with Sun West Mortgage
              Company, Inc. The name and logo of Kickin' Cancer are owned by
              Kickin' Cancer Foundation. Advertisement. All products are subject
              to credit and property approval. Program terms and conditions are
              subject to change without prior notice. Not all products are
              available in all states or for all amounts. This information is
              provided to licensed mortgage professionals only and not for
              distribution to consumers. For licensing information, go to:{" "}
              <a
                href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/company/3277"
                title="NMLS Consumer Access"
                target="_blank"
                rel="noreferrer"
              >
                www.nmlsconsumeraccess.org
              </a>
              .
              Visit{" "}
              <a
                href="https://www.swmc.com/disclaimer"
                title="Click Here for full list of license information of Sun West Mortgage Company, Inc."
                target="_blank"
                rel="noreferrer"
              >
                www.swmc.com/disclaimer
              </a>{" "}
              for the full list of license information. All Rights Reserved. Sun
              West Mortgage Company, Inc. (NMLS ID 3277) in California holds a
              Financing Law License (#6030119) [Loans made or arranged pursuant
              to a California Financing Law license], a California Financing Law
              Branch License (#603I428) for the Corona, CA Branch Office (NMLS
              ID 363427) located at 391 N. Main Street, Suite 207, Corona, CA
              92880, licensed by the California Department of Financial
              Protection and Innovation, Phone: (866) ASK-CORP, has a DRE Real
              Estate Corporation License Endorsement (#00793885), a DRE Branch
              Office License Endorsement for the Corona, CA (NMLS ID 363427)
              Branch Office licensed by the California Department of Real
              Estate, Phone: (877) 373-4542. In all jurisdictions, the principal
              (Main) licensed location of Sun West Mortgage Company, Inc. is
              6131 Orangethorpe Avenue, Suite 500, Buena Park, CA 90620, Phone:
              (800) 453-7884
            </span>
          </Col>
        </Row>
      </Container>
    </>
  );
}
